const apiConfig: any = {
    baseUrl: process.env.VUE_APP_BASE_URL
};

export default apiConfig;
